import { useMutation, useQuery } from '@tanstack/react-query'

import { useTRPC } from '@lib/trpc'

export const useMe = (enabled = true) => {
  const trpc = useTRPC()
  const query = useQuery({ ...trpc.auth.me.queryOptions(), enabled, staleTime: 60 * 1000 })
  return { me: query.data, meLoading: query.isPending, meError: query.error, refetchMe: query.refetch }
}

export const useRequestCodeMutation = () => {
  const trpc = useTRPC()
  const mutation = useMutation(trpc.auth.requestCode.mutationOptions())
  return { requestCode: mutation.mutateAsync, requestCodeIsPending: mutation.isPending }
}

export const useUpdateProfileMutation = () => {
  const trpc = useTRPC()
  const mutation = useMutation(trpc.auth.updateProfile.mutationOptions())
  return { updateProfile: mutation.mutateAsync, updateProfileIsPending: mutation.isPending }
}
